'use client';

// npm packages
import React from 'react';
import OtpInput from 'react-otp-input';
import { useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import { EMAIL, LOGIN_ERROR_MESSAGE } from '@/constants';
import ErrorMessage from './ErrorMessage';

function OTPNumberInput({ otpInputRef, otp, setOtp, activeTab }) {
  const { errorMessage, isNumberOfAttemptExceeded, isResendAttemptExceeded } =
    useSelector((state) => state.auth);
  const { WRONG_OTP, LAST_ATTEMPT } = LOGIN_ERROR_MESSAGE;
  return (
    <>
      <OtpInput
        ref={otpInputRef}
        value={otp}
        onChange={setOtp}
        numInputs={6}
        autoFocus
        shouldAutoFocus
        inputType="tel"
        renderSeparator={<span>&nbsp;&nbsp;</span>}
        renderInput={(props) => (
          <input {...props} disabled={isNumberOfAttemptExceeded} />
        )}
        inputStyle={cn(
          '!w-[40px] h-[40px] bg-white text-senate text-[27px] font-encode-sans !font-semibold border leading-24 tracking-[0.5px] rounded-[4px] outline-hawk-grey border-hawk-grey',
          errorMessage.length &&
            errorMessage !== 'last-resend-attempt' &&
            !isResendAttemptExceeded &&
            '!outline-infrared-burn !border-infrared-burn',
        )}
      />
      {errorMessage === WRONG_OTP && !isNumberOfAttemptExceeded ? (
        <ErrorMessage
          className=" items-start text-left pl-8  mt-10 w-[282px]"
          textPrimary="Wrong OTP entered. Please try again."
          type="otpError"
        />
      ) : null}

      {errorMessage === LAST_ATTEMPT ? (
        <ErrorMessage
          className=" items-start text-left pl-8  mt-10 w-[282px]"
          textPrimary="You have one more OTP attempt left"
          type="otpError"
        />
      ) : null}

      {isNumberOfAttemptExceeded ? (
        <ErrorMessage
          className=" items-start text-left pl-8  mt-10 w-[282px]"
          textPrimary={`Too many OTP verification attempted. Login with this ${activeTab === 'phone' ? 'number' : EMAIL} is locked for few minutes.`}
          type="otpError"
        />
      ) : null}
    </>
  );
}

export default OTPNumberInput;
